import React,{useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { createUserProfileDocument, auth } from "../../utils/firebase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import './styles.css'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    fontSize: '1.5rem'
  },
  menu :{
    fontSize: '1.2rem',
  },
 
}));

export default function SignSeeker() {
  const classes = useStyles();


  const [fields, setFields] = useState({
    firstName:"",
    lastName:"",
    email: "",
    password: "",
    phoneNumber: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(name,value)
    setFields({ ...fields, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password, firstName,lastName, phone } = fields;
    const name=firstName+lastName;
    console.log(fields)
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        email,
        password
      );
      createUserProfileDocument(user, {name , phone });
    } catch (error) {
      console.error(error);
    }

    setFields({
      email: "",
      password: "",
      firstName:"",
      lastName:"",
      phone: "",
    });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Tell us something about yourself
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                value={fields.firstName}
                onChange={handleChange}

                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                value={fields.lastName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} style={{fontSize: '1.2rem', border: '1px solid grey', padding: '10px 15px', width: '100%'}}>
        Are you a 
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}className= {classes.menu}>Woman</MenuItem>
        <MenuItem onClick={handleClose}className= {classes.menu}>Group of Women</MenuItem>
        <MenuItem onClick={handleClose}className= {classes.menu}>Organisation</MenuItem>
      </Menu>
            </Grid>
            <Grid item xs={6}>
            <TextField
                name="edu"
                value={fields.firstName}
                onChange={handleChange}

                variant="outlined"
                fullWidth
                id="edu"
                label="Highest Education Qualification"  
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
               name="numberwomen"
               value={fields.firstName}
               onChange={handleChange}

               variant="outlined"
               fullWidth
               id="firstName"
               label="For a group, please specify number of women" 
      
              />
            </Grid>
            {/* <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="I want to receive inspiration, marketing promotions and updates via email."
              />
            </Grid> */}
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Let's get started
          </Button>
        </form>
      </div>
    </Container>
  );
}





      